export default __webpack_public_path__ + "static/media/banner-blog-2.3a0a133e.png";